// Copied from Acend
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from "@chakra-ui/react";
import React, { forwardRef } from "react";

const buttonStyles = {
  primary: {
    bg: "linear-gradient(hsl(227, 94%, 68%), hsl(216, 69%, 49%))",
    color: "white",
    border: 0,
    _hover: {
      bg: "linear-gradient(hsl(227, 94%, 63%), hsl(216, 69%, 44%))",
    },
    _active: {
      bg: "linear-gradient(hsl(227, 94%, 58%), hsl(216, 69%, 39%))",
    },
  },
  secondary: {
    bg: "linear-gradient(hsl(227, 93%, 40%), hsl(227, 93%, 29%))",
    color: "white",
    border: 0,
    _hover: {
      bg: "linear-gradient(hsl(227, 93%, 35%), hsl(227, 93%, 24%))",
    },
    _active: {
      bg: "linear-gradient(hsl(227, 93%, 30%), hsl(227, 93%, 19%))",
    },
  },
  standard: {
    bg: "hsl(210, 38%, 95%)",
    color: "black",
    border: 0,
    _hover: {
      bg: "hsl(210, 38%, 90%)",
    },
    _active: {
      bg: "hsl(210, 38%, 85%)",
    },
  },
  positive: {
    bg: "linear-gradient(hsl(148, 48%, 43%), hsl(150, 48%, 35%))",
    color: "white",
    border: 0,
    _hover: {
      bg: "linear-gradient(hsl(148, 48%, 38%), hsl(150, 48%, 30%))",
    },
    _active: {
      bg: "linear-gradient(hsl(148, 48%, 33%), hsl(150, 48%, 25%))",
    },
  },
  negative: {
    bg: "linear-gradient(hsl(4, 85%, 59%), hsl(3, 84%, 40%))",
    color: "white",
    border: 0,
    _hover: {
      bg: "linear-gradient(hsl(4, 85%, 54%), hsl(3, 84%, 35%))",
    },
    _active: {
      bg: "linear-gradient(hsl(4, 85%, 49%), hsl(3, 84%, 30%))",
    },
  },
  orange: {
    bg: "linear-gradient(hsl(22, 89%, 54%), hsl(22, 89%, 40%))",
    color: "white",
    border: 0,
    _hover: {
      bg: "linear-gradient(hsl(22, 89%, 49%), hsl(22, 89%, 35%))",
    },
    _active: {
      bg: "linear-gradient(hsl(22, 89%, 44%), hsl(22, 89%, 30%))",
    },
  },
  white: {
    bg: "white",
    color: "black",
    border: 0,
    _hover: {
      bg: "gray.100",
    },
    _active: {
      bg: "gray.200",
    },
  },
  link: {
    variant: "link",
    border: 0,
    color: "blue.400",
    _active: {
      color: "blue.400",
    },
    _disabled: {
      color: "blue.100",
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none",
    },
  },
  outline: {
    bg: "white",
    borderWidth: "2px",
    borderColor: "gray.500",
    color: "black",
  },
};

export type ButtonVariants =
  | "standard"
  | "primary"
  | "secondary"
  | "positive"
  | "negative"
  | "orange"
  | "white"
  | "link"
  | "outline";

export interface ButtonProps extends ChakraButtonProps {
  variant?: ButtonVariants;
  disabled?: never;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "standard", ...baseProps }, ref) => {
    return <ChakraButton ref={ref} {...buttonStyles[variant]} {...baseProps} />;
  }
);

export default Button;
